import { Component, Input, OnInit } from '@angular/core';
import { BuyerApiService } from '../../shared/services/buyer-api/survey.service';
import { Constants } from '../constants/margin-report-constants';

@Component({
  selector: 'ps-ui-margin-report',
  templateUrl: './margin-report.component.html',
  styleUrls: ['./margin-report.component.css'],
})
export class MarginReportComponent implements OnInit {
  @Input() surveyId!: number | undefined;

  public MARGIN_REPORT_OPTIONS = Constants.MARGIN_REPORT_OPTIONS;
  public marginReportMode!: string;
  public surveyMarginValue!: number;
  public surveyMarginPercentage!: number;

  constructor(private _buyerApiService: BuyerApiService) {}

  ngOnInit(): void {
    this.getReport(this.MARGIN_REPORT_OPTIONS[0]);
  }

  getReport(option: { label: string; value: string }) {
    this.marginReportMode = option.label;
    this._buyerApiService
      .getMarginReportData(this.surveyId, option.value)
      .subscribe((response: any) => {
        this.surveyMarginValue = response.value;
        this.surveyMarginPercentage = response.percentage;
      });
  }
}
